<template>
  <div id="relic_wrap" class="absolute bottom-8 left-1/2 z-10 text-center">
    <div class="relative">
      <p class="text-2xl py-2">유물 리스트</p>
      <button
        class="bg-gray-300 absolute top-3 right-4 p-3 rounded-full"
        @click="$emit('close')"
      >
        <img src="../assets/images/close_btn.png" alt="닫기" class="w-2" />
      </button>
    </div>

    <div v-if="!items.length">저장한 유물이 없습니다</div>
    <div v-if="items.length">
      <ul class="grid grid-cols-3 m-auto gap-y-5 gap-x-5 w-11/12 pt-5 pb-12">
        <li
          @click="onClick(item)"
          class="w-full bg-white text-center m-auto rounded-xl py-5"
          v-for="(item, index) in items"
          :key="`relic_${index}`"
        >
          <div class="img_wrap" v-if="item.relics">
            <img
              :src="`${API_URL}${SERVICE_API_URL}/files/load/${item.relics.image}`"
              :alt="item.id"
            />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { API_URL, SERVICE_API_URL } from "../common/config";
export default {
  name: "GalleryRelicList",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      API_URL: "",
      SERVICE_API_URL: "",
    };
  },
  created() {
    this.API_URL = API_URL;
    this.SERVICE_API_URL = SERVICE_API_URL;
  },
  methods: {
    onClick(item) {
      this.$emit("handleClick", { item });
    },
  },
};
</script>

<style>
#relic_wrap {
  width: 95%;
  border: 2px solid #fff;
  border-radius: 10px;
  height: 28vh;
  overflow: scroll;
  transform: translateX(-50%);
  background: rgba(0,0,0,.3);
}

#relic_wrap .img_wrap {
  width: 4rem;
  height: 4rem;
  margin: auto;
  position: relative;
}

#relic_wrap img {
  display: block;
  margin: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
